import angular from 'angular';
import ngRedux from 'ng-redux';
import 'angular-gettext';

import appStateModule from '../../state/state.module';
import apiModule from '../../api/api.module';

import {assetListComponent, AssetListController} from './asset-list.component';
import {assetListFooterComponent, AssetListFooterController} from './asset-list-footer/asset-list-footer.component';

/** Asset List page module */
export default angular
  .module('components.asset-list', [appStateModule, apiModule, ngRedux, 'gettext'])
  // Asset List body
  .component('assetList', assetListComponent)
  .controller('AssetListController', AssetListController)

  // Asset List footer
  .component('assetListFooter', assetListFooterComponent)
  .controller('AssetListFooterController', AssetListFooterController).name;
